module.exports = __webpack_public_path__ + "static/images/paper.c9a311bf647f1e81cb7b730fb580f4e8.svg";